import { genBlock } from "@/utils/bem";
import * as React from "react";
import classNames from "classnames";
import "./style.less";

interface VerticalCardProps {
  imgUrl?: string;
  imgStyle?: React.CSSProperties;
  descStyle?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  align?: "left" | "center";
  title?: string;
  descList?: string[];
  isDescIcon?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const blockName = "c-vertical-card";
const block = genBlock(blockName);

/**
 * @example
    imgUrl?: string;
    imgStyle?: React.CSSProperties;
    descStyle?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
    align?: 'left' | 'center';
    title?: string;
    descList?: string[];
    isDescIcon?: boolean;
    className?: string;
    style?: React.CSSProperties;
 */
export const VerticalCard: React.FC<VerticalCardProps> = ({
  imgUrl,
  align = "left",
  title,
  descList,
  isDescIcon = false,
  className,
  style = {},
  imgStyle = {},
  descStyle = {},
  titleStyle = {},
}) => {
  const [showStyle, setShowStyle] = React.useState<React.CSSProperties>({});

  const handleoreClick = () => {
    setShowStyle({ display: "block" });
  };

  return (
    <div
      className={classNames(block(), className, block("", align))}
      style={style}
    >
      {imgUrl ? (
        <div className={block('img-wrap')} style={imgStyle}>
          <img src={imgUrl} alt=""  className={block("img")} />
        </div>
      ) : null}
      {title ? (
        <p className={block("title")} style={titleStyle}>
          {title}
        </p>
      ) : null}
      {descList ? (
        <ul
          className={classNames(block("desc-list"), {
            "show-icon": isDescIcon,
          })}
          style={showStyle}
        >
          {Array.isArray(descList) &&
            descList?.map((desc, index) => (
              <li className={block("desc-item")} key={index} style={descStyle}>
                <p>{desc}</p>
              </li>
            ))}
        </ul>
      ) : null}
      {descList && (
        <p
          className={block("more")}
          style={showStyle.display ? { display: "none" } : {}}
          onClick={handleoreClick}
        >
          了解更多
        </p>
      )}
    </div>
  );
};
